import React from "react";
// import companylogo from "../../assets/GreenOrelg.png";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import companylogo from "../../assets/GreenOrelg.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import { data } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaUserAlt } from "react-icons/fa";
import AnalyticsIcon from "@mui/icons-material/Analytics";

export default function LargeScreenNav(props) {
	const { siteLogo } = props;
	const navLinks = [
		{ title: "dashboard", url: "", icon: <DashboardIcon />, id: 1 },
		{
			title: "Create Shipment",
			url: "/dctdashboard/admin/create-shipment",
			icon: <SearchIcon />,
			id: 2,
		},
		{
			title: "Update Shipment",
			url: "/dctdashboard/admin/update-shipment",
			icon: <ShoppingBasketIcon />,
			id: 3,
		},
		// {
		// 	title: "Analytics",
		// 	url: "/dctdashboard/admin/analytics",
		// 	icon: <AnalyticsIcon />,
		// 	id: 4,
		// },
		// { title: "Orders", icon: <MonetizationOnIcon />, id: 4 },
	];

	const navLinks2 = [
		// { title: "support", icon: <HeadphonesIcon />, id: 1 },
		{
			title: "settings",
			url: "/dctdashboard/admin/admin-setting",
			icon: <SettingsIcon />,
			id: 1,
		},
		{ title: "logout", url: "logout", icon: <LogoutIcon />, id: 2 },
	];

	const content = (
		<section className="min-h-screen       w-[20%]  bg-[#034052]  text-white  flex flex-col justify-start  items-start   gap-[2rem]      fixed">
			<img src={siteLogo} alt="Green Ore Logo" className="p-[1rem]" />
			<ul className=" w-[80%]   min-h-[10rem]   text-left  tracking-wide    gap-[1rem] flex  flex-col  ml-[3rem]    justify-center items-start">
				{navLinks.map((data) => (
					<li>
						{data.icon}{" "}
						<Link to={data.url} className="   font-bold  ">
							{data.title}
						</Link>{" "}
					</li>
				))}
			</ul>

			<ul className=" w-[80%]   min-h-[10rem]   text-left  tracking-wide    gap-[1rem] flex  flex-col  ml-[3rem]    justify-center items-start">
				{navLinks2.map((data) => (
					<li>
						{data.icon}{" "}
						<Link to={data.url} className="   font-bold  ">
							{data.title}
						</Link>{" "}
					</li>
				))}
			</ul>

			{/* <ul className=" w-[80%]   min-h-[10rem]   text-left  tracking-wide   gap-[1rem] flex  flex-col  ml-[3rem]    justify-center items-start">
				{navLinks2.map((data) => (
					<li>
						{data.icon} <Link className="   font-bold  ">{data.title}</Link>{" "}
					</li>
				))}
			</ul> */}
		</section>
	);

	return content;
}
